export default __webpack_public_path__ + "static/media/ic-ascenseur.2c9cf60c.svg";